module.exports = __webpack_public_path__ + "img/Weapon_262.91131680.png";